import React from 'react';
import { Typography } from '@mui/material';
import { styled } from 'styled-components';
import Loader from '../../components/Loader/Loader';

const Container = styled.div`
  margin-top: 4em;
`;

const PageNotFound = () => (
  <Container>
    <Typography
      sx={{
        marginTop: '-50px',
        fontSize: 30,
        variant: 'body2',
        color: 'text.secondary',
        textAlign: 'center',
      }}
    >
      Page not found!
    </Typography>
    <Loader mainLoader />
  </Container>
);

export default PageNotFound;
